import { getMatomoSiteId, getMatomoUrl } from "@/analytics";
import { AnalyticsTracker } from "@/analytics/AnalyticsTracker";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "react-hot-toast";

export const Route = createRootRoute({
  component: () => (
    <>
      <AnalyticsTracker matomoUrl={getMatomoUrl()} siteId={getMatomoSiteId()} />
      <Toaster position="top-right" />
      <Outlet />
    </>
  ),
});
